var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm btn-info",on:{"click":_vm.clipboard}},[_c('i',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }